import equalByNameAndPaymentParametersId from '../../utils/equalByNameAndPaymentParametersId';
import dateConverter from '../../../../utils/converters/date.converter';
import {i18n} from "../../../vue-i18n";

export default class ChangePaymentEndDate {
  constructor(paymentParametersId, newEndDate) {
    this.commandName = "ChangePaymentEndDate";

    this.paymentParametersId = paymentParametersId;
    this.newEndDate = newEndDate;

    const convertedDate = dateConverter.convertToDate(newEndDate);
    this.description =
      `${i18n.t('CONTENT.events.new_endDate')}: ${i18n.d(convertedDate)}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewEndDate: this.newEndDate
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParametersId(this, other);
}
